import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import type { CatalogElement } from "../models/CatalogElement";

export const getCatalogElements = async (signal?: AbortSignal) => {
  const apiService = new MESApiService();

  return await apiService.callV2("[LAB].[GetCatElements]", [], signal);
};
export const upsertCatalogElement = async (element: CatalogElement) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [
    { name: "Id", value: element.ElementId },
    { name: "Name", value: element.ElementName },
    { name: "Decimals", value: element.Decimals },
    { name: "Order", value: element.Order },
    { name: "Enabled", value: element.IsActive },
  ];

  return await apiService.callV2("[LAB].[UpsertCatElement]", parameters);
};
export const getCatalogElement = async (ElementId: number | null) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [{ name: "ElementId", value: ElementId }];

  return await apiService.callV2("[LAB].[GetCatElement]", parameters);
};
